import { render, staticRenderFns } from "./QuestionTypeDropdown.vue?vue&type=template&id=73675f1e"
import script from "./QuestionTypeDropdown.vue?vue&type=script&lang=js"
export * from "./QuestionTypeDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports